<template>
  <v-content class="db-content">

      <v-tabs
        centered
        class="tabs"
        background-color="#0f1724"

      >
      <v-tab>
        Intellectual
      </v-tab>
      <v-tab>
        <!-- <v-icon left>
          mdi-access-point
        </v-icon> -->
        Legal
      </v-tab>
      <v-tab>
        <!-- <v-icon left>
          mdi-access-point
        </v-icon> -->
        Market Research
      </v-tab>
      <v-tab >
        <!-- <v-icon left>
          mdi-account
        </v-icon> -->
        Marketing
      </v-tab>
      <v-tab>
        <!-- <v-icon left>
          mdi-lock
        </v-icon> -->
        Pitch
      </v-tab>
      <v-tab>
        <!-- <v-icon left>
          mdi-access-point
        </v-icon> -->
        Projections
      </v-tab>

      <v-tab>
        <!-- <v-icon left>
          mdi-lock
        </v-icon> -->
        Sales
      </v-tab>
      <v-tab>
        <!-- <v-icon left>
          mdi-access-point
        </v-icon> -->
        Staff
      </v-tab>
      <v-tab>
        <!-- <v-icon left>
          mdi-access-point
        </v-icon> -->
        Technology
      </v-tab>

      <v-tab-item>

        <v-card class="db-content-2">

 
          <v-col
            cols="12"
            sm="12"
          >
            <v-sheet
              min-height="63vh"
              rounded="lg"
              class="data-card"
            >
              <v-row
                class="d-flex-row"
                align="center"
                justify="center"
              > 



          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            I.P. STRATEGY
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/cogneetiv.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/file/d/1kul9apTx7v8IgGwufwgS_2_RcPqEhW4E/view?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD STRATEGY

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                



                <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            PATENT APPLICATION
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/PatenetApplicationNumber.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/file/d/1TH0O0DeKIfEriUWncjZ4BHPi9cTEur5l/view?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD PATENT APPLICATION

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                

                
              </v-row>
            </v-sheet>
          </v-col>

       
 
 
           
        </v-card>
      </v-tab-item>
      <v-tab-item>

        <v-card class="db-content-2">

 
          <v-col
            cols="12"
            sm="12"
          >
            <v-sheet
              min-height="63vh"
              rounded="lg"
              class="data-card"
            >
              <v-row
                class="d-flex-row"
                align="center"
                justify="center"
              > 
                <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            JOHN SALINAS
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/johnsalinas.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="http://macheenist.com/assets/CogneetivAIWorkspaceAssistantPitchdeck.pdf"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"               
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD FOUNDER LEGAL 

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            ATUL VERMA
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/atulverma.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="http://macheenist.com/assets/CogneetivAIWorkspaceAssistantPitchdeck.pdf"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD CO-FOUNDER LEGAL 

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            SIGNED LEGAL
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/signedlegal.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="http://macheenist.com/assets/CogneetivAIWorkspaceAssistantPitchdeck.pdf"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              SIGNED LEGAL

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
              </v-row>
            </v-sheet>
          </v-col>

       
 
 
           
        </v-card>
      </v-tab-item>

      <v-tab-item>

        <v-card class="db-content-2">

 
          <v-col
            cols="12"
            sm="12"
          >
            <v-sheet
              min-height="63vh"
              rounded="lg"
              class="data-card"
            >
              <v-row
                class="d-flex-row"
                align="center"
                justify="center"
              > 
                <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            FEATURES & PRICING
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/pitchdeck.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/file/d/1_tfYsyz2je8YsVOBGDWTb3UuK5aXq75N/view?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD PRICING

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            LEAN CANVAS
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/businessplan.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/file/d/13qR2d0hFrUOQ0VFBU3PFjcK4kQkaa4WT/view?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD LEAN CANVAS

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            SWOT ANALYSIS
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/swot.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/file/d/1823Rj6hoRk8hZAT17OWpcHm_mK_Onq8K/view?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD ANALYSIS

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
              </v-row>
            </v-sheet>
          </v-col>

       
 
 
           
        </v-card>
      </v-tab-item>

      <v-tab-item>

        <v-card class="db-content-2">

 
          <v-col
            cols="12"
            sm="12"
          >
            <v-sheet
              min-height="63vh"
              rounded="lg"
              class="data-card"
            >
              <v-row
                class="d-flex-row"
                align="center"
                justify="center"
              > 
                <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            BRANDING
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/branding.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="drive.google.com/drive/folders/14YsvFIvVCI6TUyfFt5r5Gcp8xU0iOUOK?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD BRAND GUIDELINES 

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
          
              </v-row>
            </v-sheet>
          </v-col>
        </v-card>
      </v-tab-item>



      <v-tab-item>

        <v-card class="db-content-2">

 
          <v-col
            cols="12"
            sm="12"
          >
            <v-sheet
              min-height="63vh"
              rounded="lg"
              class="data-card"
            >
              <v-row
                class="d-flex-row"
                align="center"
                justify="center"
              > 
                <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            PITCHDECK
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/cogneetiv2.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="http://macheenist.com/assets/CogneetivAIWorkspaceAssistantPitchdeck.pdf"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD PITCHDECK 

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            ONE PAGE SNAPSHOT
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/businessplan.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="http://macheenist.com/assets/CogneetivAIWorkspaceAssistantPitchdeck.pdf"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD SNAPSHOT

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
      
                
              </v-row>
            </v-sheet>
          </v-col>

       
 
 
           
        </v-card>
      </v-tab-item>

      <v-tab-item>

        <v-card class="db-content-2">

 
          <v-col
            cols="12"
            sm="12"
          >
            <v-sheet
              min-height="63vh"
              rounded="lg"
              class="data-card"
            >
              <v-row
                class="d-flex-row"
                align="center"
                justify="center"
              > 
                <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            PROJECTIONS
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/macheenist.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/file/d/1g9DAahrZGeSwON3c_b0NtkM_r6UfV_Wd/view?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                   target="_blank"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD PROJECTIONS 

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
  
                
              </v-row>
            </v-sheet>
          </v-col>

       
 
 
           
        </v-card>
      </v-tab-item>


      <v-tab-item>

        <v-card class="db-content-2">

 
          <v-col
            cols="12"
            sm="12"
          >
            <v-sheet
              min-height="63vh"
              rounded="lg"
              class="data-card"
            >
              <v-row
                class="d-flex-row"
                align="center"
                justify="center"
              > 
                <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            SALES PROCESS
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/sales.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/file/d/192kKN_eCA6qa6kjD8dgvxn8KM_Q19OuD/view?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                  
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD SALES PROCESS 

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                

              </v-row>
            </v-sheet>
          </v-col>

       
 
 
           
        </v-card>
      </v-tab-item>

      <v-tab-item>

        <v-card class="db-content-2">

 
          <v-col
            cols="12"
            sm="12"
          >
            <v-sheet
              min-height="63vh"
              rounded="lg"
              class="data-card"
            >
              <v-row
                class="d-flex-row"
                align="center"
                justify="center"
              > 
                <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
          STAFF 
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/pitchdeck.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/file/d/1pjnt5Ei-xC0iFXUCxO67swtk7tUx6DA_/view?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                  
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD STAFF 

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            STAFF SNAPSHOT
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/businessplan.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/file/d/1KEL94DB8LV0x_abstM00ukAtMcXNyCip/view?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD STAFF SNAPSHOT

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            NEW HIRES
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/macheenist.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/file/d/1eN53nrL_HFbVusdbQTxgY3SMfwlr4Ozc/view?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD NEW HIRES

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
              </v-row>
            </v-sheet>
          </v-col>

       
 
 
           
        </v-card>
      </v-tab-item>

      <v-tab-item>

        <v-card class="db-content-2">

 
          <v-col
            cols="12"
            sm="12"
          >
            <v-sheet
              min-height="63vh"
              rounded="lg"
              class="data-card"
            >
              <v-row
                class="d-flex-row"
                align="center"
                justify="center"
              > 




           <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            DIAGRAMS
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/pitchdeck.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/drive/folders/1NYadG7MVozCxaRYCQMpjiT3sCecwNzND?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                  
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD DIAGRAMS 

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            RESEARCH & DEVELOPMENT
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/businessplan.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/drive/folders/1rkCz3UqNcs98qcNXmh5J3RQR-NtCDbV8?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD RESEARCH

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>



                <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            DRAWINGS
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/pitchdeck.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/drive/folders/18mFhnwh0qbuPK95u-nSx1-M3mHIVgvC3?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                  
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD DRAWINGS 

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            BACKLOG
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/businessplan.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/drive/folders/1VRw3sA6qMDoLDSHMO4S3elQmExBqHtS7?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD BACKLOG

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>
                
          <v-col
                  cols="4"
                  sm="4"
                >

                  <v-card-text>
            <p class="text-2">
            SCREENSHOTS
            </p>

          </v-card-text>
           <img class="center" style="height: 60%; width: 60%" src="@/assets/macheenist.png" />
             <v-flex class="spaceroom" />
                <v-btn
                   href="https://drive.google.com/drive/folders/1pf2IkLwmhY5nSmY7m7I84YRZekLw23yo?usp=sharing"
                   class="button"
                   outlined
                   color="white"
                 >
                  <div class="text">         
                    <v-row>
                      <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-microphone
                        </v-icon>
                               
                      </v-col>
                                       <v-col
                        cols="1"
                      >
                        <v-icon
                          left
                          class="mr-2"
                        >
                          mdi-download
                        </v-icon>
                               
                      </v-col>
                                         <v-col
                        cols="3"
                      >
 
                              DOWNLOAD SCREENSHOTS

                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                                           <v-flex class="spaceroom" />
                      </v-col>
                        
                    </v-row>
                  </div>
                 </v-btn>
                </v-col>




              </v-row>
            </v-sheet>
          </v-col>

       
 
 
           
        </v-card>
      </v-tab-item>



    </v-tabs>







    <v-overlay :value="overlay" opacity="0.99" z-index="9">
     <!-- <v-btn class="mx-2 close-btn" fab dark small color="#ccc" @click="overlay = false">X</v-btn> -->
    <v-card v-scroll.self="onScroll">

      <CommandAssistant v-if="type=='commands'"/>
      <CommandAssistant2 v-if="type=='commandAssistant2'"/>
      <CommandAssistant3 v-if="type=='commandAssistant3'"/>
      <Calendar v-if="type=='calendar'"/>
      <Email v-if="type=='email'"/>
      <VideoPlayer v-if="type=='mix'"/>
      <VideoPlayerTwo v-if="type=='night'"/>
      <VideoPlayerThree v-if="type=='tech'"/>
      <VideoPlayerFour v-if="type=='smooth'"/>
      <VideoPlayerFive v-if="type=='cyber'"/>
      <VideoPlayerSix v-if="type=='rap'"/>
      <VideoPlayerSeven v-if="type=='chill'"/>
      <VideoPlayerEight v-if="type=='hits'"/>
      <!-- <VideoChat v-if="type=='video'"/>
      <ScreenShare v-if="type=='share'"/> -->
    </v-card> 
  </v-overlay>

          </v-content>
  
   
        </template>



<script>

import CommandAssistant from '../components/CommandAssistant.vue';
import CommandAssistant2 from '../components/CommandAssistant2.vue';
import CommandAssistant3 from '../components/CommandAssistant3.vue';
import Calendar from '../components/Calendar.vue';
import VideoPlayer from '../components/VideoPlayer.vue';
import VideoPlayerTwo from '../components/VideoPlayerTwo.vue';
import VideoPlayerThree from '../components/VideoPlayerThree.vue';
import VideoPlayerFour from '../components/VideoPlayerFour.vue';
import VideoPlayerFive from '../components/VideoPlayerFive.vue';
import VideoPlayerSix from '../components/VideoPlayerSix.vue';
import VideoPlayerSeven from '../components/VideoPlayerSeven.vue';
import VideoPlayerEight from '../components/VideoPlayerEight.vue';
import Email from '../components/Email.vue';
export default {
  name: "Dashboard",
  data: () => ({
          links: [
        'Intellectual',
        'Legal',
        'Market Research',
        'Marketing',
        'Pitch',
        'Projections',
        'Sales',
        'Staff',
        'Technology'
      ],
    dashboard:{},
    overlay:false,
    type:''
  }),
  
  components:{

    CommandAssistant,
    CommandAssistant2,
    CommandAssistant3,
    Calendar,
    Email,
    VideoPlayer,
    VideoPlayerTwo,
    VideoPlayerThree,
    VideoPlayerFour,
    VideoPlayerFive,
    VideoPlayerSix,
    VideoPlayerSeven,
    VideoPlayerEight,
  },

  
  computed: {
  },


storage: { type: String, default: "local" },
// show tree view
tree: { type: Boolean, default: true },
// file icons set
axios: { type: Function },
// custom configuration for internal axios instance
axiosConfig: { type: Object, default: () => {} },
// max files count to upload at once. Unlimited by default
maxUploadFilesCount: { type: Number, default: 0 },
// max file size to upload. Unlimited by default
maxUploadFileSize: { type: Number, default: 0 },

  methods: {
    getDashboard: async function(){
        const rawResponse = await fetch("http://localhost:3000/analytics/all");
          const content = await rawResponse.json();
          this.dashboard = content.response;
          console.log(content)
    },
   readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1.5;
      speech.rate = 1;
      speech.pitch = 1;
      speech.text = msg;
      speech.lang = 'en-GB';
      window.speechSynthesis.speak(speech);
      speech.onend = function () {
        Event.$emit("speakModeOn");
      };
      // this.alert = "true";
    },

  },




  mounted() {
    this.getDashboard();
    Event.$on("showCard", (data) => {
      console.log(data)
      if (data.msg.indexOf("calendar") != -1) {
        this.type ='calendar'
      }
      this.overlay=true;
    });
    Event.$on("showEmail", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("email") != -1) {
        this.type ='email'
      }
      this.overlay=true;
    });
    Event.$on("showCommands", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("commands") != -1) {
        this.type ='commands'
      }
      this.overlay=true;
    });
    Event.$on("showVideo", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("video") != -1) {
        this.type ='video'
      }
      this.overlay=true;
    });
    Event.$on("showShare", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("share") != -1) {
        this.type ='share'
      }
      this.overlay=true;
    });
    Event.$on("playMix", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("mix") != -1) {
        this.type ='mix'
      }
      this.overlay=true;
    });
    Event.$on("playNight", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("night") != -1) {
        this.type ='night'
      }
      this.overlay=true;
    });
    Event.$on("playTech", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("tech") != -1) {
        this.type ='tech'
      }
      this.overlay=true;
    });
    Event.$on("playChill", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("chill") != -1) {
        this.type ='chill'
      }
      this.overlay=true;
    });
    Event.$on("playSmooth", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("smooth") != -1) {
        this.type ='smooth'
      }
      this.overlay=true;
    });
    Event.$on("playCyber", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("cyber") != -1) {
        this.type ='cyber'
      }
      this.overlay=true;
    });
    Event.$on("playRap", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("rap") != -1) {
        this.type ='rap'
      }
      this.overlay=true;
    });
    Event.$on("playHits", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      if (data.msg.indexOf("hits") != -1) {
        this.type ='hits'
      }
      this.overlay=true;
    });
    Event.$on("closeCard", (data) => {
      if (this.$route.path !== "/interface") {
        return;
      }
      console.log(data)
      this.overlay=false
    });
  },
};
</script>


<style scoped>
.about{
  padding: 20px;
  
}
.card{
  margin-left: 1rem;
  padding: 20px;
  width: 100%;
  height: 425px;
  cursor: pointer;
}
.row{
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
}


.flexbox {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  height: 350px;
  overflow: hidden;
  margin: 0 auto;
  padding: 0px;
  transition: all 1s ease-in-out;
}

.flexbox:hover {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  height: 425px;
  overflow: hidden;
  margin: 0 auto;
  padding: 0px;
  transition: scale(1.1);
}


.flexbox .board {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  max-width: 100%;
  background-color: transparent;
  padding: 0px;

}

.flexbox .board .card {
  padding: 5px;
  background: rgba(48, 64,87, 0.3);
  outline-color: #42da91;
  color: #fff;
  min-width: 390px;
  max-width: 390px;
  cursor: pointer;
}


.ma-2 {
  width: 180px;
  transition: all 0.7s ease-in-out;
}

.ma-2:hover {
  width: 220px;
  transition: scale(1.1);
}


.html, body{
width: 100%;
height: 100%;
padding: 0;
margin: 0;
background-color:#222;
font-size: 0;
}
.svg{
display: block;
width: 100%;
height: 100%;
padding: 0;
margin: 0;
position:absolute;

}
.h1{
width: 100%;
font-family: sans-serif;
position:absolute;
text-align:center;
color:white;
font-size: 18px;
top: 40%;
opacity: 1;
transition: opacity 1s ease-in-out;
-moz-transition: opacity 1s ease-in-out;
-webkit-transition: opacity 1s ease-in-out;
}

.h1 a{
  color: #48b1f4;
  text-decoration:none;
}

.path{
stroke-linecap: square;
stroke: white;
stroke-width: 0.5px;
}


.space {
  height: 20px;
}

.theme-icons {
  background: #304057;
  color: #fff;
  size: 100px;
}

.theme-icons:hover {
  background: #304057;
  color: #fff;
}


.theme-bg-player {
 width: 800px;
}


.animation {
  position: relative;
  top: 0px;
  font-size: 15px;
  min-height: 0px;
  left: 0%;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}


.animation2 {
  position: absolute;
  top: 180px;
  font-size: 15px;
  min-height: 0px;
  left: 0%;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}


.animation3 {
  position: absolute;
  top: 440px;
  font-size: 15px;
  min-height: 0px;
  left: -32%;
  right: 0%;
  border-radius: 10px;
  color: #fff;
}


.animation4 {
  position: absolute;
  top: 440px;
  font-size: 15px;
  min-height: 0px;
  left: 32%;
  right: 0%;
  border-radius: 10px;
  color: #fff;
}



.animation5 {
  position: relative;
  top: -1050px;
  font-size: 15px;
  min-height: 0px;
  left: -10 %;
  right: 0%;
  border-radius: 10px;
  color: #fff;
}

.tabs {
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
  background: rgb(9, 1, 24, 0.7);
  outline-color: #42da91;
  color: #fff;
}


.data-card {
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
  background: rgb(9, 1, 24, 0.6);
  outline-color: #42da91;
  color: #fff;
  width: 100%;
  padding: 40px;
}

.theme-bg-card {
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
  background: #192b44;
  outline-color: #42da91;
  color: #fff;

}


.theme-bg-card-2 {
  background: rgba(46, 47, 53, 1);
  outline-color: #5a80bf;
  color: #fff;
  border: 5px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}

.theme-bg-card-warning {
  background: rgba(255, 255, 0, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}

.theme-bg-card-warning:hover {
  background: rgba(255, 255, 0, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(0,255,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;

}

.theme-bg-card-negative {
  background: rgba(255, 0, 0, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}

.theme-bg-card-negative:hover {
  background: rgba(255, 0, 0, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #FF0000;
	box-shadow: 0 0 5px rgba(255,0,0,.2), inset 0 0 5px rgba(255,0,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;

}

.theme-bg-card-lg {
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}

.theme-bg-card-lg:hover {
  background: rgba(16, 22, 58, 0.5);
  outline-color: #42da91;
  outline-style: solid;
	animation: glow 1000ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 7px rgba(0,255,0,.2), inset 0 0 7px rgba(0,255,0,.1), 0 2px 0 #000;
	outline: none;

}

@keyframes glow {
    0% {
		border-color: #393;
		box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(120,166,156,.1), 0 2px 0 #000;
    }

    100% {
		border-color: #78b59c;
		box-shadow: 0 0 8px rgba(0,255,0,.8), inset 0 0 10px rgba(120,166,156,.4), 0 2px 0 #000;
    }
}


.space1 {
  height: 35px;
}

.space2 {
  height: 1px;
}

.spaceroom {
  height: 15px;
}
.space3 {
  height: 1px;
}

.space4 {
  height: 1px;
}


.tabbar {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    & > li {
        margin: 0 11px;
        & > svg {
            width: 14px;
            height: 14px;
            display: block;
            fill: #2F3545;
            transition: opacity .3s ease;
        }
    }
    &.open {
        & > li {
            & > svg {
                opacity: .5;
            }
        }
    }
}

.Center & dribbble
body {
    min-height: 100vh;
    font-family: Roboto, Arial;
    color: #ADAFB6;
    background: #171C28;
    display: flex;
    justify-content: center;
    align-items: center;
    .dribbble {
        position: fixed;
        display: block;
        right: 20px;
        bottom: 20px;
        img {
            display: block;
            height: 28px;
        }
    }
}

.text-color-2 {
  color: #42da91 !important;
}

.user-ui {
  background: rgba(48, 64, 87, 1);
  opacity: 1;
  color: #fff;
  padding: 20px;
}

.theme-bg-2 {
  background: rgba(48, 64, 87, 0.3);
  color: #fff;
}
.menu-icon {
  background: rgba(48, 64, 87, 0.3);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.menu-icon:hover {
  background: rgba(48, 64, 87, 0.5);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.close-btn {
  position: absolute;
  right: 0px;
  margin-top: -60px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.icons {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
  color: #42da91 !important;
}
.icons:hover {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  padding: 0px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  color: #ffffff !important;
}
.detail-card {
  width: 800px;
  height: 400px;
  background: #304057;
  opacity: .75;
  position: absolute;
}

.button{
  text-decoration: none;
  width: 65%;
  left: 15%;
  justify-content: center;
  padding: 80px;
  margin: 10px;
  font-family: Arial, Helvetica, sans-serif;
  color: #fff;
}

.text{
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  text-align: center;
}
.text-2{
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  text-align: center;
}
.chart {
  color: #fff;
	background: #304057;
	background-size: 400% 400%;
  margin-left: 0px;
  padding: 25px;
  width: 404px;
  cursor: pointer;
  top: -60px;
  min-height: 10vh;
	-webkit-animation: gradient 25s ease infinite;
	-animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
  height: 150%;
}

.db-content {
	background: linear-gradient(-45deg,  #192b44, #0f1724, #000417);

	background-size: 400% 400%;
  padding: 40px;
  min-height: 85vh;
	-webkit-animation: gradient 25s ease infinite;
	-animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
  height: 150%;
}

.db-content-2 {
	background: linear-gradient(-90deg,  #192b44, #0f1724, #000417);
  background-size: 400% 400%;
	-webkit-animation: gradient 25s ease infinite;
	-animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
  height: 150%;
}

.mobile-view {
  display: none;
}
.desktop-view {
  display: block;
}
.three-dot {
  margin-top: 10px;
  float: right;
  color: #fff;
}
.product-animate {
  animation-name: slideleft;
  position: relative;
  position-fromTop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;
}
.product-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromTop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.info-animate {
  animation-name: slideleft;
  position: relative;
  position-fromTop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;

}
.info-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromTop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.product {
  width: 400px;
}
/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: 0px;
  }
  100% {
    left: 10px;
    top: 0px;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@keyframes slidetop {
  0% {
    bottom: -1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@keyframes slidebottom {
  0% {
    bottom: 1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}


.slideExpandUp{
	animation-name: slideExpandUp;
	-webkit-animation-name: slideExpandUp;

	animation-duration: 2.6s;
	-webkit-animation-duration: 2.6s;

	animation-timing-function: ease-out;
	-webkit-animation-timing-function: ease -out;

	visibility: visible !important;
}

@keyframes slideExpandUp {
	0% {
		transform: translateY(100%) scaleX(0.94);
	}
	30%{
		transform: translateY(-4%) scaleX(0.95);
	}
	40%{
		transform: translateY(2%) scaleX(0.96);
	}
	50%{
		transform: translateY(0%) scaleX(1);
	}
}


@-webkit-keyframes slideExpandUp {
	0% {
		-webkit-transform: translateY(100%) scaleX(0.94);
	}
	30%{
		-webkit-transform: translateY(-4%) scaleX(0.95);
	}
	40%{
		-webkit-transform: translateY(2%) scaleX(0.96);
	}
	50%{
		-webkit-transform: translateY(0%) scaleX(1);
	}
}


@media only screen and (max-width: 600px) {
  .product {
    width: 90%;
  }
  .card-margin {
    margin-top: 40px;
  }
  .mobile-view {
    display: block;
  }
  .desktop-view {
    display: none;
  }
  .db-content {
    height: 100%;
  }
  .menu-icon-2 {
    margin-left: 20px;
    color: #42da91 !important;
    margin-top: 20px;
  }
  .mb-margin {
    text-align: center;
  }
  .detail-card {
    width: 350px;
    height: 100%;
  }
  .callouts {
    padding: 100px;
    border: outline;
    background: #304057;
    opacity: 0.90;
    color: #11ece5;
    cursor: pointer;
    position: relative;
    margin-left: 540px;
    margin-right: auto;
    left: 100px;
    right: 0px;
    align: center;
    text-align: center;
    outline-color: #5a80bf;
    outline-style: solid;
    animation: glow 1800ms ease-out infinite alternate;
    border-color: #5a80bf;
    box-shadow: 0 0 5px rgba(90,128,191,.2), inset 0 0 3px rgba(90,128,191,.1), 0 2px 0 #000;
    outline: none;
  }
  @keyframes glow {
    0% {
    border-color: #11ece5;
    box-shadow: 0 0 5px rgba(90,128,191,.2), inset 0 0 6px rgba(90,128,191,.4), 0 2px 0 #000;
    }

    100% {
    border-color: #11ece5;
    box-shadow: 0 0 8px rgba(90,128,191,.8), inset 0 0 10px rgba(90,128,191,.8), 0 2px 0 #000;
    }
  }


.user-speach {
  position: absolute;
  top: -350px;
  font-size: 16px;
  width: 80%;
  left: 200px;
  right: 0px;
  border-radius: 15px;
  color: #fff;
	background: linear-gradient(-45deg, #0f1724, #151f2f, #19253a, #304057, #0f1724);
	background-size: 400% 400%;

	-webkit-animation: gradient 15s ease infinite;
	-animation: gradient 15s ease infinite;
}

@-webkit-keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
  height: 150%;
}


.button{
  text-decoration: none;
    font-family: Arial, Helvetica, sans-serif;
}

.about{
  padding: 30px;
  background: rgba(48, 64, 87, 0.1);
  color: #111;
    display: flex;
    justify-content: center;
    align-items: center;
}
  .callouts:hover {
    padding: 30px;
    border: outline;
    background: #304057;
    opacity: 1;
    color: #11ece5;
    cursor: pointer;
    position: relative;
    margin-left: 540px;
    margin-right: auto;
    left: 100px;
    right: 0px;
    align: center;
    text-align: center;
  }
}
</style>